import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MicroserviceHttpService } from '../../shared/microservice-http.service';

@Injectable({ providedIn: 'root' })
export class LessonApiService extends MicroserviceHttpService {
	constructor() {
		super('lesson', 'lesson');
	}

	/**
	 * Updates a lesson's type and rebuilds the enrollment's stored lesson pattern
	 * to reflect the manual change. Use this instead of the legacy MyLanguageBird
	 * updateType endpoint, which does not update the pattern.
	 */
	changeLessonType(lessonID: number, newLessonTypeID: number): Observable<void> {
		return this.patch<void>(`${this.serviceUrl}/${lessonID}/type`, newLessonTypeID);
	}

	// The lesson plan editor's endpoints moved to Enrollment.Api, which owns the pattern and semester sizes:
	// see EnrollmentLessonPlanService.
}
